import { render, staticRenderFns } from "./PrivacyNoticePage.vue?vue&type=template&id=735f9d96&scoped=true&"
import script from "./PrivacyNoticePage.vue?vue&type=script&lang=js&"
export * from "./PrivacyNoticePage.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyNoticePage.vue?vue&type=style&index=0&id=735f9d96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735f9d96",
  null
  
)

export default component.exports